import {identity} from 'lodash';
import React from 'react';
import Button from '../common/Button';
import HelpSystemInformation from '../common/HelpSystemInformation';
import IconArrowDown from '../icons/IconArrowDown';

const Card = function (props) {

    const classNames = () => {
        let classNames = ['card', 'general-info-card'];
        if (props.className)
            classNames.push(props.className);

        return classNames.join(' ');
    }

    const defaultTitle = () => {
        return (
            <div className="card-title">
                <div className="title">
                    {props.label === "Files" &&
                        <div className={`card-files-expander ${props.isCloseFilesTable ? "close" : ""}`}
                             onClick={() => props.setIsCloseFilesTable(!props.isCloseFilesTable)}>
                            <IconArrowDown color="#000"/>
                        </div>}
                    <span>{__(props.label)}</span>
                    <HelpSystemInformation text={props.helpInfo}/>
                </div>
                <div className="card-buttons">
                    {props.customButtons && props.customButtons()}
                </div>
            </div>
        )
    }

    const renderTitle = () => {
        if (props.customTitle)
            return props.customTitle();

        return defaultTitle();
    }
    return (
        <div className={classNames()}>
            {renderTitle()}
            <div className="card-body">
                {props.children}
            </div>
        </div>
    )
}

export default Card;